import React, { useEffect } from "react";
import styles from './Contact.module.css';
import { ReactComponent as Locator} from '../../imgs/contact/locator.svg'
import emailjs from '@emailjs/browser';

export default function Contact(){

    useEffect(() => {
        window.scrollTo(0,0);
    },[]);

    const sendEmail = (e) => {
        e.persist();
        e.preventDefault();
        console.log(e.target.name.value)
        console.log(e.target.email.value)
        console.log(e.target.mobile.value)
        console.log(e.target.message.value)
        emailjs
        .sendForm(
            process.env.REACT_APP_SERVICE_ID,
            process.env.REACT_APP_TEMPLATE_ID,
            e.target,
            process.env.REACT_APP_PUBLIC_KEY
        )
        .then(
            (result) => {
                console.log('message sent');
            },
            (error) => {
                console.log('error');
            }
        );
        e.target.reset();
    }

    return (
        <main>
            <section id="aboutUsSection" className={styles.aboutUsSection}>
                <div className={`${styles.circleMask}`}>
                    <div className={styles.sectionUpper}>
                        <div className={styles.sectionText}>
                            <h2>Let's see if<br/> we can help</h2>
                        </div>
                    </div>
                </div>
                <div >
                    <div className={styles.sectionLower}>
                        <div className={styles.lowerTextContainer}>
                            <div className={styles.sectionText2}>
                                <h4>We listen first,<br/>then talk second</h4>
                                <h6>Any project, no matter the size, we are always open to provide our take on any challenge you have in mind. <br/><br/>Share some details with us by filling in the form and we will get back to you.</h6>
                            </div>
                            <div className={styles.contactForm}>
                                <h4>Get in touch</h4>
                                <form onSubmit={sendEmail}>
                                    <label>Your name *<input name="name"/></label>
                                    <label>Your email address *<input name="email"/></label>
                                    <label>Mobile number<input name="mobile"/></label>
                                    <label>How can we help?<textarea name="message"></textarea></label>
                                    <input type="submit" value="Send Message"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={styles.map}>
                <Locator className={styles.locator}/>
            </section>
        </main>
    )
}